<script setup lang="ts">

import { findLensModel }  from "@/stores/lensModelCollection"
import { getDisplayAstigmatism } from "@/helpers/toricHelper"
import { computed, type PropType } from "vue";
import type { ToricStepData } from "@/models/CalculatorResult";


const props = defineProps({
    titulo : {
        type: String,
        required: true
    },
    aConstant: {
        type: Number,
        required: true
    },
  target: {
    type: Number,
    required: true
  },
    idLen: {
      type: Number,
      required: true
    },
    cylinder: {
      type: Number,
      required: false
    },
    axis: {
      type: Number,
      required: false
    },
    toricSteps: {
      type: Array as PropType<ToricStepData[]>,
      required: false
    }
})

const model = computed(() => {
    return findLensModel(Number(props.idLen))?.name
})

// Se tiver tabela por degrau, usa o cilindro/eixo do degrau RECOMENDADO (a
// lente de verdade que o cirurgião vai pedir) em vez do valor base (T0, sem
// nenhuma lente tórica escolhida).
const display = computed(() => getDisplayAstigmatism(props))

// Quando há tabela por degrau (lente tórica cadastrada), sempre mostra —
// mesmo se o resíduo do degrau recomendado for pertinho de zero, isso já é
// informação útil (mostra que a lente corrige quase tudo). Sem tabela por
// degrau, abaixo de 0,05D o astigmatismo é clinicamente insignificante e não
// vale a pena mostrar.
const showAstigmatism = computed(() => {
    if (props.toricSteps && props.toricSteps.length > 0) {
        return true
    }
    return display.value.cylinder != undefined && display.value.cylinder > 0.05
})

</script>

<template>
    <header class="result-lens__header">
        <div class="result-lens__title-container">
            <h2 style="text-align: center"> {{ model }} </h2>
        </div>

        <div class="result-lens__a-constant-info">
            <p class="text-topic-value" style="text-align: center; margin: auto">
              <span class="text-topic-value__topic">A-Constant</span>:
              <span class="text-topic-value__value">{{ aConstant }}</span>

              <span style="margin-left: 10px" class="text-topic-value__topic">Target</span>:
              <span class="text-topic-value__value">{{ target?.toFixed(2) }}</span>

              <template v-if="showAstigmatism">
                <span style="margin-left: 10px" class="text-topic-value__topic">Cyl</span>:
                <span class="text-topic-value__value">{{ display.cylinder?.toFixed(2) }} @ {{ display.axis?.toFixed(0) }}º</span>
              </template>
            </p>

<!--            <span v-if="model" class="tag">Model: {{ model }}</span>-->
        </div>
    </header>

    <div class="result-lens__result-container">
        <table class="table-result-lens"></table>
    </div>
</template>

<style scoped lang="sass">
@use "../../assets/colors/colors"
@use "../../assets/fonts/fonts"
.result-lens
  padding: 0 7.43% 2.08em 7.43%

  &__title-container
    font-size: 2em
    height: 60px
    display: flex
    justify-items: center
    align-items: center
    justify-content: center
    align-content: center
    margin: 0

    @media print
      height: 30px

    h2
      font-weight: bold
      margin: 0

  &__a-constant-info
    display: flex
    gap: 1.6em
    font-size: 1.4em
    padding-bottom: 1.6em
    align-items: flex-start
    flex-direction: column

.table-result-lens
  border-collapse: collapse
  width: 100%
    
.tag
  display: inline-block
  padding: 0.3em 0.8em
  background-color: colors.$secondary-light
  border-radius: 0.3em

.text-topic-value__topic
  font-size: 1em
  @media print
    font-size: 1.3em
.text-topic-value__value
  font-weight: bold
  font-size: 1em
  @media print
    font-size: 1.3em

</style>